import { Injectable } from '@angular/core';

import { Department } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService extends TmsWebBaseEditService<Department, Department> {
  constructor() {
    super('Department', $localize`Department`);
  }
}
